import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=0635a9f0&scoped=true"
import script from "./Dispatch.vue?vue&type=script&lang=js"
export * from "./Dispatch.vue?vue&type=script&lang=js"
import style0 from "./Dispatch.vue?vue&type=style&index=0&id=0635a9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0635a9f0",
  null
  
)

/* custom blocks */
import block0 from "./Dispatch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports